import React, { useEffect, useRef, useState, useMemo } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import './Summary.scss';
import PricePerformance from './charts/PricePerformance';
import lodash, { findIndex, set, throttle } from 'lodash';
import DropdownPicker from '../../../components/pickers/dropdownPicker';
import LineChart from './charts/LineChart';
import moment from 'moment/moment';
import MultipleDatePicker from '../../../components/pickers/multipleDatePicker';
// import { SummaryServiceApi } from "../../../services/stockAnalysis/api";
// import { Configuration as stockAnalysisConfig } from "../../../services/stockAnalysis/configuration"
import { CurrenciesEnum, SummaryServiceApi } from "../../../services/stockAnalysis/api";
import { Configuration } from "../../../services/stockAnalysis/configuration";
import { useDispatch, useSelector } from "react-redux";
import ErrorContent from '../../../components/error-boundary';
import Spinner from '../../../components/spinner';
import Streaming from '../../../services/_realtime/price/Streaming';
import DateFormatter from '../../../formatters/DateFormatter';
import { Toast } from 'primereact/toast';
import { APIControl } from '../../../helpers/APIControl';
import PieChart from './charts/PieChart';
import { formatIndicators } from './indicatorFormat';

import pieChartDemoData from '../../../mock/pieChartDemo.json';
import { useTranslation } from "react-i18next";
import { de } from 'date-fns/locale';
const Summary = () => {
    const { t, i18n } = useTranslation();
    // Streaming refs for history and real-time subscriptions
    const streamingRef = useRef(null);
    const unsubscribeStreaming = useRef(null);
    const streamingRefRealtime = useRef(null);
    const unsubscribeStreamingRealtime = useRef(null);
    // Add new refs for unsub functions
    const streamingRefRealtimeUnSubRef = useRef(null);
    const streamingUnSubRef = useRef(null);
    // Callback for MultipleDatePicker
    const selectedDate = (firstDate, lastDate) => {
        setfirstDate(firstDate);
        setlastDate(lastDate);
        setFirstDateForHistoryDate(dateFormatter.intToTimestamp(dateFormatter.dateToInt(firstDate)));
        setLastDateForHistoryDate(dateFormatter.intToTimestamp(dateFormatter.dateToInt(lastDate)));
        setActivePeriod('Custom');
    };
    const selectedSecurity = useSelector((state) => state.security?.selectedSecurity);
    const dateFormatter = new DateFormatter();
    const apiSummary = new SummaryServiceApi(new Configuration({ basePath: process.env.REACT_APP_STOCK_ANALYSIS_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_STOCK_ANALYSIS_API_BASE_PATH));
    const user = useSelector((state) => state.auth?.user);
    const token = useSelector((state) => state.auth?.token);
    //const token = localStorage.getItem('token');
    const accountId = useSelector((state) => state.auth?.accountId);
    const toast = useRef(null);
    const [pieChartData, setPieChartData] = useState(pieChartDemoData);
    const [pieChartData1, setPieChartData1] = useState([]);
    const [pieChartData2, setPieChartData2] = useState([]);
    const [pieChartData3, setPieChartData3] = useState([]);
    const language = i18n.language;


    const indexComboData = [
        { id: 2, Code: 'XU100', Name: 'BIST 100', lastPrice: '', dailyChange: "", ObjectId: 'sec.101.411' },
        { id: 3, Code: 'XU030', Name: 'BIST 30', lastPrice: '', dailyChange: "", ObjectId: 'sec.101.409' },
        { id: 4, Code: 'XU050', Name: 'BIST 50', lastPrice: '', dailyChange: "", ObjectId: 'sec.101.410' },
        { id: 5, Code: 'XBANK', Name: 'BIST BANKA', lastPrice: '', dailyChange: "", ObjectId: 'sec.101.388' },
        { id: 1, Code: 'XUTUM', Name: 'BIST TÜM', lastPrice: '', dailyChange: "", ObjectId: 'sec.101.417' },
        { id: 7, Code: 'XUMAL', Name: 'BIST MALİ', lastPrice: '', dailyChange: "", ObjectId: 'sec.101.414' },
    ];

    const [indicators, setIndicators] = useState([]);
    const [currency, setCurrency] = useState();
    const [selectedCurrencyIndex, setSelectedCurrencyIndex] = useState();
    const [indexList, setIndexList] = useState(indexComboData);
    const [selectedIndexListItem, setSelectedIndexListItem] = useState();
    const [pricePerformanceDomId, setPricePerformanceDomId] = useState("");
    const [pricePerformanceRelativeDomId, setPricePerformanceRelativeDomId] = useState("");
    const [periods, setPeriods] = useState([]);
    const [periodPicker, setPeriodPicker] = useState([]);
    const [activePeriod, setActivePeriod] = useState('6A');
    const [chartdata, setChartData] = useState([]);
    const [firstDate, setfirstDate] = useState(moment().subtract(1, 'months').toDate());
    const [lastDate, setlastDate] = useState(new Date());
    const [entityId, setEntityId] = useState();
    const [fieldOfActivity, setFieldOfActivity] = useState("");
    const [pricePerformanceDataRelative, setPricePerformanceDataRelative] = useState([]);
    const [pricePerformanceDataAbsolute, setPricePerformanceDataAbsolute] = useState([]);
    const [indicatorsSpinner, setIndicatorsSpinner] = useState(false);
    const [pricePerformansRelativeSpinner, setPricePerformansRelativeSpinner] = useState(false);
    const [pricePerformanceSpinner, setPricePerformanceSpinner] = useState(false);
    const [isLoadingLineChart, setIsLoadingLineChart] = useState(true);
    const [firstDateForHistoryDate, setFirstDateForHistoryDate] = useState();
    const [lastDateForHistoryDate, setLastDateForHistoryDate] = useState();
    const [chartAddData, setChartAddData] = useState();
    const throttledUpdate = useRef(throttle((newPoint) => {
        setChartAddData(newPoint);
    }, 500)).current;
    const [showFieldActivityModal, setShowFieldActivityModal] = useState(false);
    //#region Dummy Data
    const periodsData = ['1G', '1H', '1A', '6A', '1Y', '3Y', '5Y'];
    // const periodsData = ['1Y', '3Y', '5Y', '7Y', '8Y', '10Y', '15Y', '20Y', '30Y', '40Y' ];


    const periodPickerComboData = [
        {
            id: 1,
            name: '1 DK',
        },
        {
            id: 2,
            name: '5 DK',
        },
        {
            id: 3,
            name: '10 DK',
        },
        {
            id: 4,
            name: '15 DK',
        },
        {
            id: 5,
            name: '1S',
        },
        {
            id: 6,
            name: '3S',
        },
        {
            id: 7,
            name: '4S',
        },
    ];

    const currencyComboData = [
        {
            id: 0,
            name: t('currency.turkishLira'),
        },
        {
            id: 1,
            name: 'USD',
        },
        {
            id: 2,
            name: 'Euro',
        },
    ];

    //#endregion Dummy Data
    let args = {
        Platform: "hisselab",
        Symbol: selectedSecurity.id,
        StartDate: moment().add(-1, 'y').unix(),
        EndDate: moment().unix(),
        Resolution: "1D",
        FieldType: "",
    }

    useEffect(() => {
        if (pieChartData !== undefined && pieChartData !== null) {
            handlePieChartData();
        }
        let data1 = [{ "Name": "Other", "Percentage": 100, "UniqueCode": "Other" }];
        let data2 = lodash.sortBy(lodash.unionBy(pieChartDemoData[0].Peers, "UniqueCode"), "Percentage").reverse()
        let data3 = lodash.sortBy(pieChartDemoData[0].Securities, "Percentage").reverse()

        setPieChartData1(data1)
        setPieChartData2(data2)
        setPieChartData3(data3)

    }, [pieChartData]);


    useEffect(() => {
        setCurrency(currencyComboData);
        setSelectedCurrencyIndex(currencyComboData[0]);
    }, [t]);


    useEffect(() => {
        setSelectedIndexListItem(indexComboData[0]);
        setPeriods(periodsData);
        setPeriodPicker(periodPickerComboData);
    }, []);

    useEffect(() => {
        if (selectedSecurity !== null) {
            setEntityId(selectedSecurity.id);
        }
    }, [selectedSecurity.id]);

    useEffect(() => {
        if (entityId !== undefined && entityId !== null) {
            getIndicatorDataService();
            getFieldofActivityData();
            getPricePerformanceRelativeData();
        }
    }, [entityId]);

    useEffect(() => {
        if (selectedIndexListItem !== undefined) {
            getPricePerformanceRelativeData();
        }
    }, [selectedIndexListItem]);

    useEffect(() => {

        if (selectedCurrencyIndex && selectedCurrencyIndex.name && entityId !== undefined && entityId !== null) {
            getPricePerformanceAbsoluteData();
        }
    }, [selectedCurrencyIndex, entityId]);


    // Helper: filter valid objectIds
    const getValidObjectIds = (objectIds) => {
        if (!Array.isArray(objectIds)) return [];
        return objectIds.filter(id => !!id && id !== '');
    };

    useEffect(() => {
        setIsLoadingLineChart(true);
        setChartData([]);      // clear previous chart data on period change
        setChartAddData(null); // reset any pending realtime point

        // Setup args dates based on activePeriod
        let hesaplananStartDate, hesaplananEndDate;
        if (activePeriod === "1G") {
            hesaplananStartDate = moment().add(-1, 'd').unix();
            hesaplananEndDate = moment().unix();
        }
        else if (activePeriod === "1H") {
            hesaplananStartDate = moment().add(-1, 'w').unix();
            hesaplananEndDate = moment().unix();
        }
        else if (activePeriod === "1A") {
            hesaplananStartDate = moment().add(-1, 'M').unix();
            hesaplananEndDate = moment().unix();
        }
        else if (activePeriod === "3A") {
            hesaplananStartDate = moment().add(-3, 'M').unix();
            hesaplananEndDate = moment().unix();
        }
        else if (activePeriod === "6A") {
            hesaplananStartDate = moment().add(-6, 'M').unix();
            hesaplananEndDate = moment().unix();
        }
        else if (activePeriod === "1Y") {
            hesaplananStartDate = moment().add(-1, 'y').unix();
            hesaplananEndDate = moment().unix();
        }
        else if (activePeriod === "3Y") {
            hesaplananStartDate = moment().add(-3, 'y').unix();
            hesaplananEndDate = moment().unix();
        }
        else if (activePeriod === "5Y") {
            hesaplananStartDate = moment().add(-5, 'y').unix();
            hesaplananEndDate = moment().unix();
        }
        else if (activePeriod === "7Y") {
            hesaplananStartDate = moment().add(-7, 'y').unix();
            hesaplananEndDate = moment().unix();
        }
        else if (activePeriod === "8Y") {
            hesaplananStartDate = moment().add(-8, 'y').unix();
            hesaplananEndDate = moment().unix();
        }
        else if (activePeriod === "10Y") {
            hesaplananStartDate = moment().add(-10, 'y').unix();
            hesaplananEndDate = moment().unix();
        }
        else if (activePeriod === "15Y") {
            hesaplananStartDate = moment().add(-15, 'y').unix();
            hesaplananEndDate = moment().unix();
        }
        else if (activePeriod === "20Y") {
            hesaplananStartDate = moment().add(-20, 'y').unix();
            hesaplananEndDate = moment().unix();
        }
        else if (activePeriod === "30Y") {
            hesaplananStartDate = moment().add(-30, 'y').unix();
            hesaplananEndDate = moment().unix();
        }
        else if (activePeriod === "40Y") {
            hesaplananStartDate = moment().add(-40, 'y').unix();
            hesaplananEndDate = moment().unix();
        }
        else if (activePeriod === "50Y") {
            hesaplananStartDate = moment().add(-50, 'y').unix();
            hesaplananEndDate = moment().unix();
        }
        else if (activePeriod === "Custom" && firstDateForHistoryDate !== null && lastDateForHistoryDate !== null) {
            hesaplananStartDate = firstDateForHistoryDate;
            hesaplananEndDate = lastDateForHistoryDate;
        }

        // Unsubscribe previous subscription if any
        if (streamingUnSubRef.current) {
            streamingUnSubRef.current.Dispose?.();
            streamingUnSubRef.current = null;
        }

        const symbol = selectedSecurity?.id;
        const objectIds = getValidObjectIds([symbol]);
        if (!objectIds.length) return;

        if (!streamingRef.current) {
            streamingRef.current = new Streaming();
        }

        const argsForHistory = {
            Platform: "hisselab",
            Symbol: symbol,
            StartDate: hesaplananStartDate,
            EndDate: hesaplananEndDate,
            Resolution: "1D",
            FieldType: "",
        };
        
        streamingRef.current.history(
            argsForHistory,
            (bars) => {
                processHistoryData(bars);
                setIsLoadingLineChart(false);
            },
            (error) => {
                console.error("History error:", error);
                setIsLoadingLineChart(false);
            }
        );

        return () => {
            if (streamingUnSubRef.current) {
                streamingUnSubRef.current.Dispose?.();
                streamingUnSubRef.current = null;
            }
        };
    }, [selectedSecurity, activePeriod, firstDateForHistoryDate, lastDateForHistoryDate]);

    useEffect(() => {
        // Real-time streaming setup when chart data is loaded (if needed)
        // Unsubscribe previous real-time streaming
        if (streamingRefRealtimeUnSubRef.current) {
            streamingRefRealtimeUnSubRef.current.Dispose?.();
            streamingRefRealtimeUnSubRef.current = null;
        }

        const objectIds = getValidObjectIds([selectedSecurity?.id]);
        if (!objectIds.length || !chartdata || chartdata.length === 0) return;

        if (!streamingRefRealtime.current || typeof streamingRefRealtime.current.subscribe !== 'function') {
            streamingRefRealtime.current = new Streaming();
        }

        if (typeof streamingRefRealtime.current.subscribe === 'function') {
            streamingRefRealtimeUnSubRef.current = streamingRefRealtime.current.subscribe(
                { objectIds },
                (data) => {
                    if (!data) return;
                    if (Array.isArray(data) || data.isHistoryData === true || data.type === 'history_batch') {
                        processHistoryData(data?.bars || data?.history || data);
                    } else {
                        processStreamingData(data);
                    }
                },
                (error) => {
                    console.error("Real-time streaming error:", error);
                }
            );
        }

        // Cleanup on unmount/change
        return () => {
            if (streamingRefRealtimeUnSubRef.current) {
                streamingRefRealtimeUnSubRef.current.Dispose?.();
                streamingRefRealtimeUnSubRef.current = null;
            }
        };
    }, [selectedSecurity.id, chartdata]);

    //#region LineChart

    const processHistoryData = (data) => {
        
        if (!data || data.length === 0) {
            setIsLoadingLineChart(false);
            return;
        }

        try {
            const dataMapped = data.map(res => ({
                Date: res.time,
                Close: res.close,
                Volume: res.volume || 0,
            }));
            setChartData(dataMapped);
            setIsLoadingLineChart(false);
        } catch (error) {
            setIsLoadingLineChart(false);
        }
    }

    const processStreamingData = (msg) => {

        try {
            const cmd = msg['@'];
            if (!cmd) return;

            if (cmd === 'heartbeat' || cmd === 'handshake' || cmd === 'Handshake') return;

            if (!msg.lastPrice) return;

            const lastUpdateTime = msg.lastUpdateTime
                ? dateFormatter.timestampMSToDate(msg.lastUpdateTime)
                : new Date();

            throttledUpdate({
                Date: lastUpdateTime,
                Close: msg.lastPrice,
                Volume: msg.dailyVolume || 0,
            });
        } catch (error) {
            // silently ignore streaming parse errors
        }
    }

    //#endregion LineChart

    //#region  DropdownPicker
    const onCurrencyListChange = (e) => {
        try {
            let index = findIndex(currency, { id: e.id });
            setSelectedCurrencyIndex(currency[index]);
        } catch (error) {
            // ignore
        }
    }

    const onIndexListChange = (e) => {
        let index = findIndex(indexComboData, { id: e.id });
        setSelectedIndexListItem(indexComboData[index]);
    }
    //#endregion  DropdownPicker

    //#region Periods
    const clickPeriod = (period) => {
        setActivePeriod(period);
        setFirstDateForHistoryDate(null);
        setLastDateForHistoryDate(null);
        if (streamingRefRealtimeUnSubRef.current) {
            streamingRefRealtimeUnSubRef.current.Dispose?.();
            streamingRefRealtimeUnSubRef.current = null;
        }
        if (streamingUnSubRef.current) {
            streamingUnSubRef.current.Dispose?.();
            streamingUnSubRef.current = null;
        }
    }

    //#endregion DATE PICKER

    //#region API CALLS

    //#region İndikator Data

    const getIndicatorDataService = () => {
        setIndicatorsSpinner(true);
        const culture = language;
        apiSummary.stockanalysisIndicatorsGet(token, culture, entityId).then((res) => {
            // Yeni halka arz olmuş hisselerde servis veri dönmez; kullanıcıya hata gösterme, panel boş kalsın
            if (res.data.error && res.data.error.length > 0) {
                console.warn('getIndicatorDataService: ', res.data.error);
                setIndicators([]);
                return;
            }

            setIndicators(formatIndicators(res.data.items, t));

        }).catch((err) => {
            // console.log(err);
            console.log('getIndicatorDataService: ', err);
            setIndicators([]);
        }).finally(() => {
            setIndicatorsSpinner(false);
        });
    }

    //#endregion İndikator Data

    //#region faaliyet Alanı Data

    const getFieldofActivityData = () => {
        /* culture neye göre geçilicek */
        const culture = language;

        apiSummary.stockanalysisFieldofactivityGet(token, culture, entityId
        ).then((res) => {
            if (res.data.error !== "") {
                // Veri yoksa önceki hissenin metni ekranda kalmasın
                setFieldOfActivity("");
                return;
            }
            setFieldOfActivity(res.data.value || "");
        }).catch((err) => {
            console.log(err);
            setFieldOfActivity("");
        });

        // const data = {
        //     "value": "Şirketin faaliyet konusu, sağlık kuruluşlarında kullanılan tıbbi flasterler, ilk yardım bantları ve kapsikumlu romatizma yakısı üretimi, alım satımı ile ithalat ve ihracatıdır.",
        //     "error": ""
        // }

    }

    //#endregion faaliyet Alanı Data

    //#region Price Chart Data


    //#endregion Price Chart Data

    //#region Price Performans Göreceli Data

    const getPricePerformanceRelativeData = () => {
        setPricePerformansRelativeSpinner(true)
        if (entityId === undefined || entityId === null) {
            setPricePerformansRelativeSpinner(false)
            return;
        }

        apiSummary.stockanalysisPriceperfomanceRelativeGet(token, selectedIndexListItem["ObjectId"], entityId).then((res) => {

            // Yeni halka arz olmuş hisselerde geçmiş performans verisi yoktur; hata gösterme, panel boş kalsın
            if (res.data.error !== "" || !res.data.relativePerformances?.[0]?.data) {
                if (res.data.error !== "") {
                    console.warn('getPricePerformanceRelativeData: ', res.data.error);
                }
                setPricePerformanceDataRelative([]);
                return;
            }


            let data = res.data.relativePerformances[0].data;
            let keys = Object.keys(res.data.relativePerformances[0].data);

            let formattedData = [];
            keys.forEach((key, idx) => {
                let obj = {
                    "id": idx,
                    "Name": "",
                    "change": data[key],
                }

                if (key in RelTranslations) {
                    obj["Name"] = RelTranslations[key];
                }

                formattedData.push(obj);
            });

            setPricePerformanceDataRelative(formattedData);
        }).catch((err) => {

            console.log('getPricePerformanceRelativeData: ', err);
            setPricePerformanceDataRelative([]);
            // setPricePerformanceRelativeError(true);
        }).finally(() => {
            setPricePerformansRelativeSpinner(false)
        });

        const RelTranslations = {
            "annual": t('period.yearly'),
            "monthly": t('period.monthly'),
            "weekly": t('period.weekly'),
            "ytd": t('period.ytdShort')
        };

    }

    //#endregion Price Performans Göreceli Data

    //#region Price Performans Mutlak Data

    const getPricePerformanceAbsoluteData = () => {
        setPricePerformanceSpinner(true);

        const RelTranslations = {
            "annual": t('period.yearly'),
            "monthly": t('period.monthly'),
            "weekly": t('period.weekly'),
            "ytd": t('period.ytdShort')
        };
        if (entityId === undefined || entityId === null) {
            setPricePerformanceSpinner(false);
            return;
        }
        apiSummary.stockanalysisPriceperfomanceAbsoluteGet(token, selectedCurrencyIndex.id, entityId).then((res) => {
            // Yeni halka arz olmuş hisselerde geçmiş performans verisi yoktur; hata gösterme, panel boş kalsın
            if (res.data.error !== "" || !res.data.absolutes?.[0]?.data) {
                if (res.data.error !== "") {
                    console.warn('getPricePerformanceAbsoluteData: ', res.data.error);
                }
                setPricePerformanceDataAbsolute([]);
                return;
            }
            else {
                let data = res.data.absolutes[0].data;
                let keys = Object.keys(res.data.absolutes[0].data);
                let formattedData = [];
                keys.forEach((key, idx) => {
                    let obj = {
                        "id": idx,
                        "Name": "",
                        "change": data[key],
                    }

                    if (key in RelTranslations) {
                        obj["Name"] = RelTranslations[key];
                    }

                    formattedData.push(obj);
                });

                setPricePerformanceDataAbsolute(formattedData);
            }

        }).catch((err) => {
            console.log("getPricePerformanceAbsoluteData: " + err);
            setPricePerformanceDataAbsolute([]);
        }).finally(() => {
            setPricePerformanceSpinner(false)
        });
    }

    //#endregion Price Performans Mutlak Data

    //#region Endeks Data

    //#endregion Endeks Data

    //#endregion API CALLS


    //#region PIE CHART DATA  



    const handlePieChartData = () => {
        // let data = pieChartData.Data.Report.Allocation.List;
        let formattedData = [];

        // data.forEach((item, index) => {
        //     let obj = {
        //         "id": index,
        //         "Name": item.name,
        //         "change": item.value,
        //     }

        //     formattedData.push(obj);
        // }
        // );
        // return formattedData;
    }



    const toggleFieldActivityModal = () => {
        setShowFieldActivityModal(!showFieldActivityModal);
    };

    const memoChartData = useMemo(() => {
        return chartdata.map(d => ({
            Date: d.Date,
            Close: d.Close,
            Volume: d.Volume || 0,
        }));
    }, [chartdata]);

    return (
        <div className="stock-summary-screen">
            {/* <h1>Summary</h1> */}
            <Toast ref={toast} position='bottom-right' />

            {/* AmChart Test view */}
            {/* <Row>
                <Col>

                    <PieChart divId={'div1'} chartData={pieChartData1} />
                </Col>
                <Col>

                    <PieChart divId={'div2'} chartData={pieChartData2} />

                </Col>
                <Col>

                    <PieChart divId={'div3'} chartData={pieChartData3} />

                </Col>
            </Row> */}

            <Container className='desc-box'>
                <Row>
                    <Col lg='12' className='text-align-left'>
                        <label className='desc-title'>
                            {t('stockAnalysis.activityArea')}
                        </label>
                    </Col>
                    <Col lg='12' className='text-align-left'>
                        <div className='position-relative'>
                            <label className='desc-content roboto-regular-14'>
                                {fieldOfActivity && fieldOfActivity.length > 400
                                    ? `${fieldOfActivity.substring(0, 400)}...`
                                    : fieldOfActivity}
                            </label>
                            {fieldOfActivity && fieldOfActivity.length > 400 && (
                                <div className='text-right mt-2'>
                                    <span
                                        className='text-primary cursor-pointer roboto-medium-14'
                                        onClick={toggleFieldActivityModal}
                                        style={{ color: '#418079', cursor: 'pointer' }}
                                    >
                                        {t('continue')}
                                    </span>
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>

            {/* Field of Activity Modal */}
            <Modal
                show={showFieldActivityModal}
                onHide={toggleFieldActivityModal}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{t('stockAnalysis.activityArea')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='roboto-regular-14'>{fieldOfActivity}</div>
                </Modal.Body>
            </Modal>

            <Container className='box-container-floor-one'>
                <Row>
                    <Col lg='8' md='12' className='chart-box-col'>
                        <div className='chart-box'>
                            <div style={{ position: 'relative' }}>
                                {isLoadingLineChart && (
                                    <div style={{ position: 'absolute', inset: 0, zIndex: 10 }}>
                                        <Spinner height="440px" />
                                    </div>
                                )}
                                <LineChart data={memoChartData} addData={chartAddData} securitytInfo={selectedSecurity} />
                            </div>
                            <div className='period-row transition'>
                                {periods && periods.map((period) => (
                                    <div key={"periods" + period} className={`period-item roboto-medium-14 ${activePeriod === period ? 'active' : ''}`} onClick={() => clickPeriod(period)}>
                                        {t('period.short.' + period, period)}
                                    </div>
                                ))}
                                <MultipleDatePicker selectedDate={selectedDate} firstDate={firstDate} lastDate={lastDate} />
                            </div>
                        </div>
                    </Col>
                    <Col lg='4' md='12' className='chart-box-col-right'>
                        <div className='chart-box'>
                            <Container>
                                <Row className='header-row'>
                                    <Col className='text'>
                                        <div>
                                            {t('stockAnalysis.indicators')}
                                        </div>
                                    </Col>
                                </Row>

                                {/* {indicatorsError && <ErrorContent />} */}
                                {indicatorsSpinner && <Spinner />}
                                {!indicatorsSpinner && (!indicators || indicators.length === 0) && (
                                    <div className='no-data-message'>{t('noDataForSymbol')}</div>
                                )}
                                {!indicatorsSpinner && indicators && indicators.map((item, index) =>
                                    <Row className='content-row' key={"indicators" + index}>

                                        <Col className='text'>
                                            <div>
                                                {item.name}
                                            </div>
                                        </Col>

                                        <Col className='text right'>
                                            <div>
                                                {item.value}
                                            </div>
                                        </Col>
                                    </Row>
                                )}


                            </Container>
                        </div>
                    </Col>
                </Row>




            </Container >

            <Container className='box-container-floor-two'>
                <Row>
                    <Col lg='6' md='12' className='chart-box-col'>
                        <div className='chart-box'>

                            <div className='header-row'>
                                <label className='title'>
                                    {t('stockAnalysis.pricePerformance')} - {t('stockAnalysis.absolute')}
                                </label>

                                <label>
                                    <DropdownPicker placeholder="" className='' listData={currency} selectedListItem={selectedCurrencyIndex} onListItemChange={onCurrencyListChange} icon={true} />
                                </label>
                            </div>

                            {/* {pricePerformanceAbsoluteError && <ErrorContent />} */}
                            {pricePerformanceSpinner && <Spinner />}
                            {!pricePerformanceSpinner && pricePerformanceDataAbsolute.length === 0 && (
                                <div className='no-data-message'>{t('noDataForSymbol')}</div>
                            )}
                            {!pricePerformanceSpinner && pricePerformanceDataAbsolute.length > 0 && (<PricePerformance data={pricePerformanceDataAbsolute} domId={'pricePerformanceAbsolute'} />)}

                        </div>
                    </Col>
                    <Col lg='6' md='12' className='chart-box-col-right'>
                        <div className='chart-box'>
                            <div className='header-row'>
                                <label className='title'>
                                    {t('stockAnalysis.pricePerformance')} - {t('stockAnalysis.relative')}
                                </label>

                                <label>
                                    <DropdownPicker placeholder="" className='' listData={indexList} selectedListItem={selectedIndexListItem} optionLabel="Name" onListItemChange={onIndexListChange} icon={true} />
                                </label>
                            </div>
                            {/* {pricePerformanceRelativeError && <ErrorContent />} */}
                            {pricePerformansRelativeSpinner && <Spinner />}
                            {!pricePerformansRelativeSpinner && pricePerformanceDataRelative.length === 0 && (
                                <div className='no-data-message'>{t('noDataForSymbol')}</div>
                            )}
                            {!pricePerformansRelativeSpinner && pricePerformanceDataRelative.length > 0 && (<PricePerformance data={pricePerformanceDataRelative} domId={'pricePerformanceRelative'} />)}

                        </div>
                    </Col>
                </Row>
            </Container >
        </div >
    )
}
export default Summary;
